import _regeneratorRuntime from "/app/node_modules/babel-runtime/regenerator";
import _asyncToGenerator from "/app/node_modules/babel-runtime/helpers/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations, mapState, mapActions, mapGetters } from "vuex";
import { required, email, maxLength, numeric, minLength } from "vuelidate/lib/validators";
import { emailErrorMessagesMixin, stepForm, onlyNumbersMixin, onlyLettersMixin, lettersAndNumbersMixin } from "~/mixins";
import { withParams } from "vuelidate/lib/validators/common";
import { onlyLetters, onlyEmail, charactersSpecial, noSpecialChars } from "~/validators";
import { WarningError } from "~/abstractions/errors";
import template from "./functionals/autocomplete-template";
import { affiliationTypeEnum } from "~/enums";
import loader from "../modals/loader";
import { MasterApi } from "../../api";

export default {
  mixins: [emailErrorMessagesMixin, stepForm, onlyNumbersMixin, onlyLettersMixin, lettersAndNumbersMixin],
  components: {
    loader: loader
  },
  data: function data() {

    return {
      sending: false,
      codigoAgenciaMatriz: null,
      oficinaMatriz: null,
      tipoOficinaMatriz: null,
      ubigeoOficinaMatriz: null,
      codigoMacroRegion: null,
      macroRegion: null,
      area: null
    };
  },

  validations: {
    codigoAgenciaMatriz: {
      required: required
    },
    codigoMacroRegion: {
      required: required
    }

  },
  methods: {
    getInfo: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.sending = true;
                // this.$refs.loaderModal.showLoader();        
                this.codigoAgenciaMatriz = this.$store.state.affiliations.form.corresponsaliaData.agentData.codigoAgenciaMatriz;
                this.oficinaMatriz = this.$store.state.affiliations.form.corresponsaliaData.agentData.oficinaMatriz;
                this.tipoOficinaMatriz = this.$store.state.affiliations.form.corresponsaliaData.agentData.tipoOficinaMatriz;
                this.ubigeoOficinaMatriz = this.$store.state.affiliations.form.corresponsaliaData.agentData.ubigeoOficinaMatriz;
                this.codigoMacroRegion = this.$store.state.affiliations.form.corresponsaliaData.agentData.codigoMacroRegion;
                this.macroRegion = this.$store.state.affiliations.form.corresponsaliaData.agentData.macroRegion;
                this.area = this.$store.state.affiliations.form.corresponsaliaData.agentData.area;
                this.sending = false;
                // this.$refs.loaderModal.hideLoader();

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getInfo() {
        return _ref.apply(this, arguments);
      }

      return getInfo;
    }(),
    onSubmit: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.sending = true;
                // this.$refs.loaderModal.showLoader();
                _context2.next = 3;
                return this.$store.dispatch("affiliations/form/saveAgentData", {
                  codigoAgenciaMatriz: this.codigoAgenciaMatriz,
                  oficinaMatriz: this.oficinaMatriz,
                  tipoOficinaMatriz: this.tipoOficinaMatriz,
                  ubigeoOficinaMatriz: this.ubigeoOficinaMatriz,
                  codigoMacroRegion: this.codigoMacroRegion,
                  macroRegion: this.macroRegion,
                  area: this.area
                });

              case 3:
                this.sending = false;

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function onSubmit() {
        return _ref2.apply(this, arguments);
      }

      return onSubmit;
    }()
  },
  watch: {},

  mounted: function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              this.getInfo();

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function mounted() {
      return _ref3.apply(this, arguments);
    }

    return mounted;
  }()
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/stepper/agent-data.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/stepper/agent-data.vue
// module chunks = 0 1 2 3